import { toast } from "sonner";

/**
 * Copy text to the clipboard with standard success/failure toasts. Resolves
 * true when the copy landed, so callers with their own UI (e.g. an icon flip)
 * don't confirm a copy that failed.
 */
export async function copyToClipboard(text: string, label = "Copied"): Promise<boolean> {
  try {
    await navigator.clipboard.writeText(text);
    toast.success(label);
    return true;
  } catch {
    toast.error("Unable to copy to clipboard");
    return false;
  }
}
